import axios from 'axios'

export default {
    getSateliteChurch(){
        return axios.get('/satellite-church/')
            .then(response => {
                return response.data
            })
    },
    getSateliteDataSource(params){
        return axios.get('/satellite-church/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getSateliteChurchbyID(id){
        return axios.get('/satellite-church/' + id)
            .then(response => {
                return response.data
            })
    },    
    getListSateliteChurch(id){
        return axios.get('/satellite-church/memberlist/' + id)
            .then(response => {
                return response.data
            })
    }, 
    createSateliteChurch(formdata){
        return axios.post('/satellite-church/', formdata)
            .then(response => {
                return response.data
            })
    },
    updateSateliteChurch(id,formdata){
        return axios.put('/satellite-church/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateSateliteChurch(id){
        return axios.put('/satellite-church/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateSateliteChurch(id){
        return axios.put('/satellite-church/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    
}